// extracted by mini-css-extract-plugin
module.exports = {"negative":"Balance_negative__1ahEF","positive":"Balance_positive__2Rubf","background":"Balance_background__1dkRE"};